export default "__VITE_ASSET__JkkJorT2__"